import { defineComponent as _defineComponent } from 'vue';
import AzRating from '~/components/_next/atoms/AzRating.vue';
import AzImg from '@/components/Atoms/AzImg.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzButton from '@/components/_next/atoms/AzButton.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzRecipeCard',
  props: {
    slug: null,
    title: null,
    cover: null,
    category: null,
    wishlisted: {
      type: Boolean
    },
    rating: null,
    type: null,
    numReviews: null,
    imageLoading: null
  },
  emits: ['click:wishlist'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var router = useRouter();
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $trackers = _useNuxt2App.$trackers;
    var link = computed(function () {
      return app.localePath({
        name: 'legacy-Recipe-slug',
        params: {
          slug: props.slug
        }
      });
    });
    function gtmRecipeClick(title) {
      $trackers.gtm.pushEvent('recipe', {
        event: 'generic_event',
        event_category: 'engagement',
        event_action: 'click',
        event_label: 'recipe',
        event_name: 'generic_event',
        recipe: title
      });
    }
    function goToRecipeReviews() {
      router.push(app.localePath({
        name: 'legacy-Recipe-slug',
        params: {
          slug: props.slug
        },
        hash: '#rating-reviews'
      }));
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      router: router,
      app: app,
      $trackers: $trackers,
      link: link,
      gtmRecipeClick: gtmRecipeClick,
      goToRecipeReviews: goToRecipeReviews,
      AzRating: AzRating,
      AzImg: AzImg,
      AzIcon: AzIcon,
      AzButton: AzButton,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});